import React from 'react';
import { highlightAndSanitize } from '../../utils';

type BoldedTextProps = {
    fullString: string;
    inBold: string[];
    style?: React.CSSProperties;
};

const BoldedText = ({ fullString, inBold, style }: BoldedTextProps) => {
    const data = highlightAndSanitize(fullString, inBold, style);

    return (
        <span
            data-testid={`bolded-val-${inBold}-in-${fullString}`}
            dangerouslySetInnerHTML={{ __html: data }}
        />
    );
};

export { BoldedText };
